import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext';

export default function PrivateRoutes() {
    const { isLoading } = useAuth();
    const login = JSON.parse(localStorage.getItem("login")!) || false;

    if (isLoading) {
        return (
            <div className="loader-wrapper">
                <div className="loader">
                    <span></span><span></span><span></span><span></span><span></span>
                </div>
            </div>
        );
    }

    return login !== false ? <Outlet /> : <Navigate to={`${process.env.PUBLIC_URL}/login`} />
}